/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataSourceDto } from '../../models/data-source-dto';

export interface DatasourcesDataSourceIdGet$Plain$Params {
  dataSourceId: string;
}

export function datasourcesDataSourceIdGet$Plain(http: HttpClient, rootUrl: string, params: DatasourcesDataSourceIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourceDto>> {
  const rb = new RequestBuilder(rootUrl, datasourcesDataSourceIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('dataSourceId', params.dataSourceId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataSourceDto>;
    })
  );
}

datasourcesDataSourceIdGet$Plain.PATH = '/datasources/{dataSourceId}';
